import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useOverview(fromDate: string, toDate: string) {
  return useQuery({
    queryKey: ["platformAnalytics", "overview", fromDate, toDate],
    queryFn: () => api.getOverview({ from_date: fromDate, to_date: toDate }),
  });
}
